import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { StoreSelectorComponent } from '../../components/sucursales/store-selector';

@Component({
  selector: 'allas-encuentra-tu-tienda',

  imports: [CommonModule, MainLayout, StoreSelectorComponent],
  template: `
    <!-- Titulo Principal oculto pero indexable -->
    <h1 class="absolute left-[-9999px]">
      Encuentra tu Tienda | Allas Repuestos
    </h1>
    <allas-main-layout [showPopularSections]="false" [showNewsletter]="false">
      <div class="min-h-screen bg-gray-50">
        <div class="px-4 py-6 lg:px-0 lg:py-0">
          <allas-store-selector></allas-store-selector>
        </div>
      </div>
    </allas-main-layout>
  `,
})
export class EncuentraTuTiendaComponent implements OnInit, OnDestroy {
  private title = inject(Title);
  private meta = inject(Meta);

  constructor() {}

  ngOnInit(): void {
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    // Cleanup si es necesario
  }

  private setMetaTags() {
    const pageTitle = 'Encuentra tu Tienda | Allas Repuestos';
    const description =
      'Encuentra la sucursal de Allas Repuestos más cercana a ti. Ubicaciones en Honduras con envío a domicilio y servicios de instalación.';
    const keywords =
      'tienda Allas Repuestos, sucursales Honduras, ubicación tienda, repuestos automotrices, envío a domicilio, instalación, garantía';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
